module.exports = __webpack_public_path__ + "static/media/4.17eafca4.jpg";